import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { ENV } from "./env";

export const SUPABASE_ENABLED = Boolean(ENV.SUPABASE_URL && ENV.SUPABASE_ANON_KEY);

export const supabase: SupabaseClient | null = SUPABASE_ENABLED
  ? createClient(ENV.SUPABASE_URL, ENV.SUPABASE_ANON_KEY, {
      auth: { persistSession: false, autoRefreshToken: false },
    })
  : null;

if (!SUPABASE_ENABLED && typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.warn("[alvion] Supabase env missing — running in offline stub mode.");
}
